import {Fancybox} from "@fancyapps/ui";

export default class ImageLightbox {
  constructor() {
    this._initialize();
  }

  _initialize() {
    Fancybox.bind("[data-fancybox]", {
      Toolbar: {
        display: {
          left: ["infobar"],
          middle: [],
          right: ["close"],
        },
      },
    });
  }

}
